@use "variables" as *;

.box {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  cursor: pointer;
}

.heading {
  padding-top: 0;
}

.category,
.icon {
  color: $content-secondary-color;
}

.iconWrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
}
